import axios from 'axios';
import { getBackendURL } from '@/util.js';

export default class SessionService {
    constructor() {
        const baseURL = getBackendURL();
        this.urls = {
            validateSession: `${baseURL}/v1/session/validate`,
        }
    }

    async validateSession() {
        let result = {
            data: null,
            error: null
        }
        try{
            let res = await axios.get(this.urls.validateSession, {
                withCredentials: true
            })
            result.data = res.data.stage
        } catch(e){
            result.error = e.response?.data || e.message
        }
        return result
    }
}